const api =
  process.env.NODE_ENV === "production"
    ? "/wp-json/gamelle/v1"
    : "https://www.la-gamelle.test/wp-json/gamelle/v1";
import axios from "axios";
export default {
  methods: {
    getEndpoint(name) {
      return api + "/" + name;
    }
  },
  data() {
    return {
      axios: axios
    };
  }
};
